import { __extends as A, __assign as y, __awaiter as v, __generator as f, __spreadArray as b } from "./index11.js";
import { resolveArguments as E, resolvePageArguments as P, resolveUserArguments as I, resolveAliasArguments as S } from "./index12.js";
import { isOffline as q } from "./index13.js";
import { Context as w } from "./index14.js";
import { EventFactory as F } from "./index15.js";
import { EventQueue as L } from "./index16.js";
import { UniversalStorage as O, getAvailableStorageOptions as z, User as C, Group as j } from "./index17.js";
import M from "./index18.js";
import { PersistedPriorityQueue as Q } from "./index19.js";
import { version as D } from "./index20.js";
import { getGlobal as T } from "./index21.js";
import { dispatch as U } from "./index22.js";
import { Emitter as G } from "./index23.js";
import { PriorityQueue as J } from "./index24.js";
var g = "This is being deprecated and will be not be available in future releases of Analytics JS", _ = T(), k = _?.analytics;
function N(m, a) {
  m === void 0 && (m = !1), a === void 0 && (a = !1);
  var r = m ? 4 : 1, t = a ? new J(r, []) : new Q(r, "event-queue");
  return new L(t);
}
function d() {
  console.warn(g);
}
var nt = (
  /** @class */
  function(m) {
    A(a, m);
    function a(r, t, e, o, i) {
      var n = this, s, u, c;
      n = m.call(this) || this, n._debug = !1, n.initialized = !1, n.user = function() {
        return n._user;
      }, n.init = n.initialize.bind(n), n.log = d, n.addIntegrationMiddleware = d, n.listeners = d, n.addEventListener = d, n.removeAllListeners = d, n.removeListener = d, n.removeEventListener = d, n.hasListeners = d, n.add = d, n.addIntegration = d;
      var h = t?.cookie, l = (s = t?.disableClientPersistence) !== null && s !== void 0 ? s : !1;
      return n.settings = r, n.settings.timeout = (u = n.settings.timeout) !== null && u !== void 0 ? u : 300, n.queue = e ?? N(t?.retryQueue, l), n._universalStorage = new O(l ? ["memory"] : ["localStorage", "cookie", "memory"], z(h)), n._user = o ?? new C(l ? y(y({}, t?.user), { persist: !1 }) : t?.user, h).load(), n._group = i ?? new j(l ? y(y({}, t?.group), { persist: !1 }) : t?.group, h).load(), n.eventFactory = new F(n._user), n.integrations = (c = t?.integrations) !== null && c !== void 0 ? c : {}, n.options = t ?? {}, M(n), n;
    }
    return Object.defineProperty(a.prototype, "storage", {
      get: function() {
        return this._universalStorage;
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.track = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return v(this, void 0, void 0, function() {
        var e, o, i, n, s, u, c = this;
        return f(this, function(h) {
          return e = E.apply(void 0, r), o = e[0], i = e[1], n = e[2], s = e[3], u = this.eventFactory.track(o, i, n, this.integrations), [2, this._dispatch(u, s).then(function(l) {
            return c.emit("track", o, l.event.properties, l.event.options), l;
          })];
        });
      });
    }, a.prototype.page = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return v(this, void 0, void 0, function() {
        var e, o, i, n, s, u, c, h = this;
        return f(this, function(l) {
          return e = P.apply(void 0, r), o = e[0], i = e[1], n = e[2], s = e[3], u = e[4], c = this.eventFactory.page(o, i, n, s, this.integrations), [2, this._dispatch(c, u).then(function(p) {
            return h.emit("page", o, i, p.event.properties, p.event.options), p;
          })];
        });
      });
    }, a.prototype.identify = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return v(this, void 0, void 0, function() {
        var e, o, i, n, s, u, c = this;
        return f(this, function(h) {
          return e = I(this._user).apply(void 0, r), o = e[0], i = e[1], n = e[2], s = e[3], this._user.identify(o, i), u = this.eventFactory.identify(this._user.id(), this._user.traits(), n, this.integrations), [2, this._dispatch(u, s).then(function(l) {
            return c.emit("identify", l.event.userId, l.event.traits, l.event.options), l;
          })];
        });
      });
    }, a.prototype.group = function() {
      for (var r = this, t = [], e = 0; e < arguments.length; e++)
        t[e] = arguments[e];
      if (t.length === 0)
        return this._group;
      var o = I(this._group).apply(void 0, t), i = o[0], n = o[1], s = o[2], u = o[3];
      this._group.identify(i, n);
      var c = this._group.id(), h = this._group.traits(), l = this.eventFactory.group(c, h, s, this.integrations);
      return this._dispatch(l, u).then(function(p) {
        return r.emit("group", p.event.groupId, p.event.traits, p.event.options), p;
      });
    }, a.prototype.alias = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return v(this, void 0, void 0, function() {
        var e, o, i, n, s, u, c = this;
        return f(this, function(h) {
          return e = S.apply(void 0, r), o = e[0], i = e[1], n = e[2], s = e[3], u = this.eventFactory.alias(o, i, n, this.integrations), [2, this._dispatch(u, s).then(function(l) {
            return c.emit("alias", o, i, l.event.options), l;
          })];
        });
      });
    }, a.prototype.screen = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return v(this, void 0, void 0, function() {
        var e, o, i, n, s, u, c, h = this;
        return f(this, function(l) {
          return e = P.apply(void 0, r), o = e[0], i = e[1], n = e[2], s = e[3], u = e[4], c = this.eventFactory.screen(o, i, n, s, this.integrations), [2, this._dispatch(c, u).then(function(p) {
            return h.emit("screen", o, i, p.event.properties, p.event.options), p;
          })];
        });
      });
    }, a.prototype.trackClick = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return v(this, void 0, void 0, function() {
        var e, o;
        return f(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./index8.js"
              )];
            case 1:
              return e = i.sent(), [2, (o = e.link).call.apply(o, b([this], r, !1))];
          }
        });
      });
    }, a.prototype.trackLink = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return v(this, void 0, void 0, function() {
        var e, o;
        return f(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./index8.js"
              )];
            case 1:
              return e = i.sent(), [2, (o = e.link).call.apply(o, b([this], r, !1))];
          }
        });
      });
    }, a.prototype.trackSubmit = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return v(this, void 0, void 0, function() {
        var e, o;
        return f(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./index8.js"
              )];
            case 1:
              return e = i.sent(), [2, (o = e.form).call.apply(o, b([this], r, !1))];
          }
        });
      });
    }, a.prototype.trackForm = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return v(this, void 0, void 0, function() {
        var e, o;
        return f(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./index8.js"
              )];
            case 1:
              return e = i.sent(), [2, (o = e.form).call.apply(o, b([this], r, !1))];
          }
        });
      });
    }, a.prototype.register = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return v(this, void 0, void 0, function() {
        var e, o, i = this;
        return f(this, function(n) {
          switch (n.label) {
            case 0:
              return e = w.system(), o = r.map(function(s) {
                return i.queue.register(e, s, i);
              }), [4, Promise.all(o)];
            case 1:
              return n.sent(), [2, e];
          }
        });
      });
    }, a.prototype.deregister = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return v(this, void 0, void 0, function() {
        var e, o, i = this;
        return f(this, function(n) {
          switch (n.label) {
            case 0:
              return e = w.system(), o = r.map(function(s) {
                var u = i.queue.plugins.find(function(c) {
                  return c.name === s;
                });
                if (u)
                  return i.queue.deregister(e, u, i);
                e.log("warn", "plugin ".concat(s, " not found"));
              }), [4, Promise.all(o)];
            case 1:
              return n.sent(), [2, e];
          }
        });
      });
    }, a.prototype.debug = function(r) {
      return r === !1 && localStorage.getItem("debug") && localStorage.removeItem("debug"), this._debug = r, this;
    }, a.prototype.reset = function() {
      this._user.reset(), this._group.reset(), this.emit("reset");
    }, a.prototype.timeout = function(r) {
      this.settings.timeout = r;
    }, a.prototype._dispatch = function(r, t) {
      return v(this, void 0, void 0, function() {
        var e;
        return f(this, function(o) {
          return e = new w(r), q() && !this.options.retryQueue ? [2, e] : [2, U(e, this.queue, this, {
            callback: t,
            debug: this._debug,
            timeout: this.settings.timeout
          })];
        });
      });
    }, a.prototype.addSourceMiddleware = function(r) {
      return v(this, void 0, void 0, function() {
        var t = this;
        return f(this, function(e) {
          switch (e.label) {
            case 0:
              return [4, this.queue.criticalTasks.run(function() {
                return v(t, void 0, void 0, function() {
                  var o, i, n;
                  return f(this, function(s) {
                    switch (s.label) {
                      case 0:
                        return [4, import(
                          /* webpackChunkName: "middleware" */
                          "./index9.js"
                        )];
                      case 1:
                        return o = s.sent().sourceMiddlewarePlugin, i = {}, this.queue.plugins.forEach(function(u) {
                          if (u.type === "destination")
                            return i[u.name] = !0;
                        }), n = o(r, i), [4, this.register(n)];
                      case 2:
                        return s.sent(), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              })];
            case 1:
              return e.sent(), [2, this];
          }
        });
      });
    }, a.prototype.addDestinationMiddleware = function(r) {
      for (var t = [], e = 1; e < arguments.length; e++)
        t[e - 1] = arguments[e];
      var o = this.queue.plugins.filter(function(i) {
        return i.name.toLowerCase() === r.toLowerCase();
      });
      return o.forEach(function(i) {
        i.addMiddleware.apply(i, t);
      }), Promise.resolve(this);
    }, a.prototype.setAnonymousId = function(r) {
      return this._user.anonymousId(r);
    }, a.prototype.queryString = function(r) {
      return v(this, void 0, void 0, function() {
        var t;
        return f(this, function(e) {
          switch (e.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "queryString" */
                "./index10.js"
              )];
            case 1:
              return t = e.sent().queryString, [2, t(this, r)];
          }
        });
      });
    }, a.prototype.use = function(r) {
      return r(this), this;
    }, a.prototype.ready = function(r) {
      return r === void 0 && (r = function(t) {
        return t;
      }), v(this, void 0, void 0, function() {
        return f(this, function(t) {
          return [2, Promise.all(this.queue.plugins.map(function(e) {
            return e.ready ? e.ready() : Promise.resolve();
          })).then(function(e) {
            return r(e), e;
          })];
        });
      });
    }, a.prototype.noConflict = function() {
      return console.warn(g), window.analytics = k ?? this, this;
    }, a.prototype.normalize = function(r) {
      return console.warn(g), this.eventFactory.normalize(r);
    }, Object.defineProperty(a.prototype, "failedInitializations", {
      get: function() {
        return console.warn(g), this.queue.failedInitializations;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(a.prototype, "VERSION", {
      get: function() {
        return D;
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.initialize = function(r, t) {
      return v(this, void 0, void 0, function() {
        return f(this, function(e) {
          return console.warn(g), [2, Promise.resolve(this)];
        });
      });
    }, a.prototype.pageview = function(r) {
      return v(this, void 0, void 0, function() {
        return f(this, function(t) {
          switch (t.label) {
            case 0:
              return console.warn(g), [4, this.page({ path: r })];
            case 1:
              return t.sent(), [2, this];
          }
        });
      });
    }, Object.defineProperty(a.prototype, "plugins", {
      get: function() {
        var r;
        return console.warn(g), (r = this._plugins) !== null && r !== void 0 ? r : {};
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(a.prototype, "Integrations", {
      get: function() {
        console.warn(g);
        var r = this.queue.plugins.filter(function(t) {
          return t.type === "destination";
        }).reduce(function(t, e) {
          var o = "".concat(e.name.toLowerCase().replace(".", "").split(" ").join("-"), "Integration"), i = window[o];
          if (!i)
            return t;
          var n = i.Integration;
          return n ? (t[e.name] = n, t) : (t[e.name] = i, t);
        }, {});
        return r;
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.push = function(r) {
      var t = this, e = r.shift();
      e && !t[e] || t[e].apply(this, r);
    }, a;
  }(G)
);
export {
  nt as Analytics
};
//# sourceMappingURL=index7.js.map
